<div class='container-float'>

  <b-alert 
    v-model="showAlertWrongUserPassword" 
    variant="warning" 
    dismissible
    class="custom-alert"
  >
    Attenzione! La Login e/o la Password risulta errata. 
  </b-alert>

  <b-row>
    <b-col cols="7">
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="2">
          <img src="@/assets/imgs/logo.jpg" style='width: 10rem;margin-left: 1.5rem;'>
        </b-col>
        <b-col cols="3">
          <h3 style="margin-top: 7rem;font-weight: 600;">&nbsp;Listino prezzi</h3>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="12">
          &nbsp;
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="8">
          <h5 style="margin-left: -2.0em;">Inserisci la tua login e la tua password per accedere all'applicazione</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="2">
          <p>Login</p>
        </b-col>
        <b-col cols="6">
          &nbsp;
        </b-col>
      </b-row>        
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <b-form-input v-model="login" placeholder="Inserisci la tua login" style="margin-left: 2.7rem;"></b-form-input>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="2">
          <p>Password</p>
        </b-col>
        <b-col cols="6">
          &nbsp;
        </b-col>
      </b-row>        
      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <b-form-input type="password" v-model="password" placeholder="Inserisci la tua password" style="margin-left: 2.7rem;"></b-form-input>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="2">
          <b-form-checkbox v-model="remember_me" style="margin-left: 1.2rem;">&nbsp;Ricordami</b-form-checkbox>
        </b-col>
        <b-col cols="6">
          Hai dimenticato la tua password? <span style="color:navy;cursor: pointer;" @click="recover_password">Clicca qui</span>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <b-button @click="execute_login" variant="primary" style="width: 100%;margin-left: 2.3rem;">Entra</b-button>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="4">
          &nbsp;
        </b-col>
        <b-col cols="7">
          <p @click="goto_register">Non hai un account? &nbsp;<span style="font-weight: 600;color: darkred;cursor: pointer;">Registrati</span></p>
        </b-col>
        <b-col cols="1">
          &nbsp;
        </b-col>
      </b-row>
    </b-col>
    
  </b-row>

</div>